import glamorous from 'glamorous'
import PropTypes from 'prop-types'
import { COLORS } from 'config'

const getFontWeight = ({ bold, light }) => {
  if (bold) return 'bold'
  if (light) return '300'
  return undefined
}

const Text = glamorous.div(({ color, bold, light, size }) => ({
  fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  lineHeight: 1.3,
  fontWeight: getFontWeight({ bold, light }),
  fontSize: size,
  color: COLORS[color]
}))

Text.propTypes = {
  color: PropTypes.oneOf(Object.keys(COLORS)),
  bold: PropTypes.bool,
  size: PropTypes.number
}

Text.defaultProps = {
  color: 'black',
  size: 16,
  bold: false,
  light: false
}

export default Text



// WEBPACK FOOTER //
// ./src/components/common/Text.js